import axios from 'axios';

export const getClientIpAddress = async () => {
  const instance = axios.create({
    baseURL: 'https://geolocation-db.com/json/',
  });
  const response = await instance.get();
  return response.data.IPv4;
};
